var exports = {
  "kv": "SelectableSettingsList.module__checkbox___UWNMST",
  "wb": "SelectableSettingsList.module__checkboxUnchecked___UWNMST",
  "xY": "SelectableSettingsList.module__checkboxChecked___UWNMST",
  "oE": "SelectableSettingsList.module__checkIcon___UWNMST",
};

module.exports = exports;
